const VirtualTryOn = {
    mounted() {
        const launchEvent = new CustomEvent('vto:auto-launch', { bubbles: true });
        this.el.dispatchEvent(launchEvent);
    }
}

export { VirtualTryOn };
